module.exports = __webpack_public_path__ + "static/accordion-6b4ec0810fe51b8d73cca09d17b0e79d.jpg";